var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedFilledCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_3118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 15.3327C12.0504 15.3327 15.3337 12.0494 15.3337 7.99935C15.3337 3.94926 12.0504 0.666016 8.00033 0.666016C3.95024 0.666016 0.666992 3.94926 0.666992 7.99935C0.666992 12.0494 3.95024 15.3327 8.00033 15.3327ZM11.5189 10.4808L10.4818 11.5179L8.00032 9.03644L5.51887 11.5179L4.48178 10.4808L6.96323 7.99935L4.48178 5.51789L5.51887 4.4808L8.00032 6.96226L10.4818 4.4808L11.5189 5.51789L9.03741 7.99935L11.5189 10.4808Z",
    fill: "#E60000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_3118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 -0.000732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedFilledCross);
export default __webpack_public_path__ + "static/media/rounded-filled-cross.b2445e017368542832014bd31480a435.svg";
export { ForwardRef as ReactComponent };